import css from './activeStatusTile.module.css'

interface IProps {
  active: boolean
}

const ActiveStatusTile = (props: IProps) => {
  return (
    <div className={css.status} data-active={props.active.toString()}>
      <span className={css.square} data-active={props.active.toString()} />
      <span>{props.active ? 'Активен' : 'Не активен'}</span>
    </div>
  )
}

export default ActiveStatusTile
